// Lightweight admin auth helpers
export const TOKEN_KEY = "besson_admin_token";
export const NAME_KEY = "besson_admin_name";

export function setAuth(token, name) {
  localStorage.setItem(TOKEN_KEY, token);
  if (name) localStorage.setItem(NAME_KEY, name);
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(NAME_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function isAuthed() {
  return Boolean(getToken());
}
